import useWizardJump from '@swf/core/hooks/useWizardJump';

const useWizardNav = (activePage: number) => {
  const { jumpBack, jumpForward } = useWizardJump();
  const goTo = (page: number, route: string) => {
    if (activePage === page) return;
    if (activePage > page) {
      return jumpBack(route);
    }
    return jumpForward(route);
  };

  return goTo;
};

export default useWizardNav;
